(function() {
  var Base, colorize,
    slice = [].slice,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Base = App.loadClass('core::Services/MapLayers/Base');

  colorize = App.load('public::geojson-colorize');

  exports.register = function(module) {
    return module.factory('Core.Services.MapLayers.PopulationMap', [
      '$http', 'Core.Services.Map', '$q', '$rootScope', 'PlantingRx.Services.PlantingRxService', 'PlantingRx.Services.LegendService', function() {
        var $rootScope, args, i, legend, rxLayer;
        args = 4 <= arguments.length ? slice.call(arguments, 0, i = arguments.length - 3) : (i = 0, []), $rootScope = arguments[i++], rxLayer = arguments[i++], legend = arguments[i++];
        return {
          "new": function() {
            var map;
            map = (function(func, args, ctor) {
              ctor.prototype = func.prototype;
              var child = new ctor, result = func.apply(child, args);
              return Object(result) === result ? result : child;
            })(exports.PopulationMap, args, function(){});
            map.rootScope = $rootScope;
            map.rxLayer = rxLayer;
            map.legend = legend;
            return map;
          }
        };
      }
    ]);
  };

  exports.PopulationMap = (function(superClass) {
    extend(PopulationMap, superClass);

    function PopulationMap() {
      this._property = bind(this._property, this);
      this.propertyTable = bind(this.propertyTable, this);
      this.recolor = bind(this.recolor, this);
      this.getGeoJSON = bind(this.getGeoJSON, this);
      return PopulationMap.__super__.constructor.apply(this, arguments);
    }

    PopulationMap.prototype.url = 'backend/grower/layers/planting-rx/populations';

    PopulationMap.prototype.getGeoJSON = function(response) {
      var ref, ref1;
      if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
        return response.data.data.layer;
      }
    };

    PopulationMap.prototype.recolor = function() {
      var json;
      if (this.geojson == null) {
        return;
      }
      json = this.geojson.toGeoJSON();
      json = this.legend.update(json, 'population');
      this.hide(this.layer_added_to);
      return this.makeMapLayer(this.layer_added_to, json);
    };

    PopulationMap.prototype.propertyTable = function(ft, layer) {
      return layer.on('click', (function(_this) {
        return function(e) {
          var elem, info, is_first_truth_strip, props, ref, strip;
          layer.unbindPopup();
          if (ft.properties != null) {
            props = ft.properties;
            info = "<div class='planting-rx population-popup'> <table class='table table-condensed margin-top-22'>";
            if (props.display_id) {
              info += _this._property('ID', props.display_id);
            }
            info += _this._property('Brand', props.hybrid_name);
            info += _this._property('Area (ac)', props.acres);
            if (props.productivity) {
              info += _this._property('Avg Yield', props.productivity);
            }
            if (props.musym) {
              info += _this._property('Soil Type', props.musym);
            }
            if (props.soil_yield) {
              info += _this._property('Soil Yield', props.soil_yield);
            }
            is_first_truth_strip = false;
            if (props.truth_strip) {
              if (props.real_strip_id) {
                strip = _.filter(_this.rxLayer.data.truth_strips, {
                  real_strip_id: props.real_strip_id
                });
              } else {
                strip = _.filter(_this.rxLayer.data.truth_strips, {
                  strip_id: props.truth_strip_id
                });
              }
              if (strip.length > 0 && strip[0].strip_id === 0) {
                info += _this._property('Population', props.population);
                is_first_truth_strip = true;
              }
            }
            if (!is_first_truth_strip) {
              info += _this._property('Population', "<input class='population' type='text' value='" + props.population + "' />");
            }
            if (props.truth_strip) {
              info += _this._property('Truth Strip', '');
            }
            if (props.irrigated && ((ref = props.irrigated) !== 'false' && ref !== 'Dryland')) {
              info += _this._property('Irrigated', '');
            }
            info += '</table>';
            if (!is_first_truth_strip) {
              info += "<div class='pull-right btn btn-primary'> <i class='fa fa-check'> </i> Save </div> <div class='clearfix'></div>";
            }
            info += '</div>';
          }
          elem = $(info);
          layer.bindPopup(elem[0]).openPopup(e.latlng);
          return elem.find('.btn').on('click', function() {
            var val;
            val = parseInt(elem.find('.population').val());
            if (!val) {
              return;
            }
            _this.rxLayer.setPopulation(props, val);
            layer.closePopup();
            return _this.rootScope.$apply();
          });
        };
      })(this));
    };

    PopulationMap.prototype._property = function(key, val) {
      return "<tr> <td><strong>" + key + "</strong></td> <td>" + val + "</td> </tr>";
    };

    return PopulationMap;

  })(Base);

}).call(this);
